import { Helmet } from "react-helmet-async";

export function Seo({ title }: { title: string }) {
  return (
    <Helmet>
      <title>{title} - ClassView</title>
    </Helmet>
  );
}
